<template>
    <div class="con-head">
        <i class="icon-close" @click="close"></i>
        <h1>顺丰券</h1>
    </div>
</template>

<script>
export default {
    methods:{
        close(){
            this.$router.push({ path:'/cn/sc/'});
        }
    }
}
</script>

<style lang="scss" scoped>
    .con-head{
        width :100%;
        max-width: 750px;
        background-color: #f2f2f2;
        text-align: center;
        height: .88rem;
        line-height: .88rem;
        position: fixed;
        margin-left: -0.18rem;
        z-index: 90;
        h1{
            font-size:34px;
            color:#000;
            font-weight:bold;
        }
        .icon-close{
            width: 48px;
            height: 48px;
            position: absolute;
            background: url("../../assets/images/coupons/clear_24px2x.png") center no-repeat;
            background-size: cover;
            top: .20rem;
            left: .42rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/coupons/heade.vue